export default {
    searchData:{
        dateRange:"",
        unitShortName:"",
        tel:"",
        state:"",
        enterpriseMobile: "",
    },
    arrJobTypes:[],
    activeTabId:"",
    activeTabLabel:"",
    activeType: "",
    tableData:[{}],
    pageData:{
        page:1,
        total:0,
        size:20
    },
    showCreateDialog:false,
    createData:{
        unitId:"",
        nick:"",
        tel:"",
        enterpriseMobile: "",
        coverUrl: "",
    },
    arrUnitForCreate:[]
}



// WEBPACK FOOTER //
// ./src/store/modules/Operation/state.js